import { IJournal, IJournalAction } from '../../../types/journal';
import { IGetRequest } from '../../../types/get_request';
import { options } from '../seo/seo';

export const BLOGS = 'blogs/ACTION';
export const BLOGS_REQUEST = 'blogs/ACTION_REQUEST';
export const BLOGS_SUCCESS = 'blogs/ACTION_SUCCESS';
export const BLOGS_FAILURE = 'blogs/ACTION_FAILURE';

export const initialState: IJournal = {
  items: [],
  pages_count: 0,
  count: 0,
};

const defaultAction: IJournalAction = {
  type: '',
  payload: {
    data: [],
    meta: {
      pagination: {
        page: 0,
        pages: 0,
        count: 0,
      },
    },
  },
};

export const profileBlogsReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case BLOGS_REQUEST:
      return state;

    case BLOGS_SUCCESS:
      return Object.assign({}, state, {
        items: action.payload.data,
        pages_count: action.payload.meta.pagination.pages,
        count: action.payload.meta.pagination.count,
      });

    case BLOGS_FAILURE:
      return Object.assign({}, state);

    default:
      return state;
  }
};

export const getProfileBlogs = (
    authorID: number,
  ): IGetRequest => {
  return {
    type: BLOGS,
    method: 'GET',
    payload: {
      pathname: '/v1/get-blog-list',
      params: [{
        name: 'author_id',
        value: authorID,
      }],
    },
    request: true,
    ...options,
  };
};
